import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Facebook, Twitter, Instagram, Youtube } from 'lucide-react';
import { MovaAstroLogo } from './MovaAstroLogo';

export function Footer() {
  return (
    <footer className="bg-gradient-to-b from-gray-800 to-gray-900 border-t-4 border-gray-600 py-12">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          {/* Brand */}
          <div>
            <MovaAstroLogo showText={true} className="mb-4" />
            <p className="text-gray-200 mb-2 font-medium">
              Your trusted guide to Vedic wisdom and Jyotish Shastra.
            </p>
            <p className="text-sm text-gray-400 mb-4 font-semibold">
              ॐ नमो भगवते वासुदेवाय
            </p>
          </div>

          {/* Services */}
          <div>
            <h4 className="mb-4 text-white text-lg font-bold">Our Services</h4>
            <ul className="space-y-2 text-gray-300">
              <li><a href="#" className="hover:text-gray-100 transition-colors font-semibold">Kundali Reading</a></li>
              <li><a href="#" className="hover:text-gray-100 transition-colors font-semibold">Daily Panchanga</a></li>
              <li><a href="#" className="hover:text-gray-100 transition-colors font-semibold">Kundali Milan</a></li>
              <li><a href="#" className="hover:text-gray-100 transition-colors font-semibold">Gemstone Selection Reading</a></li>
              <li><a href="#" className="hover:text-gray-100 transition-colors font-semibold">Career Astrology</a></li>
              <li><a href="#" className="hover:text-gray-100 transition-colors font-semibold">Muhurta Selection</a></li>
            </ul>
          </div>

          {/* Policies & Support */}
          <div>
            <h4 className="mb-4 text-white text-lg font-bold">Policies & Support</h4>
            <ul className="space-y-2 text-gray-300">
              <li><a href="#" className="hover:text-gray-100 transition-colors font-semibold">Terms & Conditions</a></li>
              <li><Link to="/terms/cancellation" className="hover:text-gray-100 transition-colors font-semibold">Cancellation Policy</Link></li>
              <li><Link to="/terms/refund" className="hover:text-gray-100 transition-colors font-semibold">Refund Policy</Link></li>
              <li><Link to="/terms/privacy" className="hover:text-gray-100 transition-colors font-semibold">Privacy Policy</Link></li>
              <li><Link to="/contact" className="hover:text-gray-100 transition-colors font-semibold">Contact Us</Link></li>
            </ul>
          </div>

          {/* Social Media & Newsletter */}
          <div>
            <h4 className="mb-4 text-white text-lg font-bold">Connect With Us</h4>
            <p className="text-gray-200 mb-4 font-medium">
              Follow us on social media for daily insights and updates.
            </p>
            <div className="flex gap-3 mb-6">
              <a href="#" className="p-3 bg-gray-700 rounded-full hover:bg-gray-600 transition-colors border-2 border-gray-500" aria-label="YouTube">
                <Youtube className="w-5 h-5 text-white" />
              </a>
              <a href="#" className="p-3 bg-gray-700 rounded-full hover:bg-gray-600 transition-colors border-2 border-gray-500" aria-label="Instagram">
                <Instagram className="w-5 h-5 text-white" />
              </a>
              <a href="#" className="p-3 bg-gray-700 rounded-full hover:bg-gray-600 transition-colors border-2 border-gray-500" aria-label="Twitter">
                <Twitter className="w-5 h-5 text-white" />
              </a>
              <a href="#" className="p-3 bg-gray-700 rounded-full hover:bg-gray-600 transition-colors border-2 border-gray-500" aria-label="Facebook">
                <Facebook className="w-5 h-5 text-white" />
              </a>
            </div>
            
            {/* Newsletter */}
            <h5 className="text-sm mb-3 text-gray-300 font-bold uppercase tracking-wide">Stay Updated</h5>
            <div className="flex gap-2">
              <input
                type="email"
                placeholder="Your email"
                className="flex-1 px-4 py-2 bg-gray-700 border-2 border-gray-500 rounded-lg text-white placeholder-gray-400 focus:outline-none focus:border-gray-400 font-medium"
              />
              <button className="p-2 bg-gradient-to-r from-gray-600 to-gray-700 hover:from-gray-500 hover:to-gray-600 rounded-lg transition-colors shadow-lg" aria-label="Subscribe">
                <Mail className="w-5 h-5 text-white" />
              </button>
            </div>
          </div>
        </div>

        <div className="pt-8 border-t-2 border-gray-700 text-center text-gray-200">
          <p className="font-bold">&copy; 2024 Mova Astro. All rights reserved. May divine grace guide your path.</p>
          <p className="mt-2 text-sm text-gray-400 font-semibold">हरि ॐ तत्सत्</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;